import { diContainer, serviceNames } from '../../service-setup/diContainer';
import { QuizApiSdk, IQuizParam, IQuizResultData } from '../../api/QuizApiSdk';
import { VtoQuiz } from '../domain/entities/VtoQuiz';

export interface IQuizApiResult {
    [key: string]: VtoQuiz[];
}

export class QuizApiRepository {
    private quizApiSdk: QuizApiSdk;
    private quizApiResult: IQuizApiResult = {};

    constructor() {
        this.quizApiSdk = diContainer.get(serviceNames.quizApiSdk);
    }

    public async getQuizApiResult(param: IQuizParam, vtoQuizApiId: string) {
        const paramString = this.getStringifyParam(param);
        const resultKey = Object.keys(this.quizApiResult).find(key => key === paramString);
        if (!resultKey) {
            await this.loadQuizApiData(param, vtoQuizApiId);
        }

        return this.quizApiResult[paramString];
    }

    private async loadQuizApiData(param: IQuizParam, vtoQuizApiId: string) {
        const data = await this.quizApiSdk.getQuizDataByQuizId(param, vtoQuizApiId);
        this.setQuizApiResult(data.results, param);
    }

    private setQuizApiResult(data: IQuizResultData[], param: IQuizParam) {
        const paramString = this.getStringifyParam(param);
        this.quizApiResult[paramString] = data.map(result => VtoQuiz.fromJson(result));
    }

    private getStringifyParam(param: IQuizParam) {
        return JSON.stringify(param);
    }
}
